import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusTopLeft20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconRadiusTopLeft20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.988 3.762h2.485a.75.75 0 0 0 0-1.5H9.988a8.75 8.75 0 0 0-8.75 8.75v2.48a.75.75 0 1 0 1.5 0v-2.48a7.25 7.25 0 0 1 7.25-7.25m-2.75 13.976a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3.5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3.5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2.5-11a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1 4.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 3.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusTopLeft20);
